export default __webpack_public_path__ + "static/media/expl-gradcam_08_EN.629d1536.png";